'use strict';

import constants from 'Constants.js';
import  _ from 'lodash';
import template from 'common-views/synchronize-commit-modal.ejs';
import {View} from 'backbone';
import eventBus from 'EventBus.js';
import $ from "jquery";

class SynchronizeCommitModalView extends View {
    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;

        return this;
    }

    closeModal() {
        this.clearEventBus();
        $(constants.SELECT_FIELD_ID).remove();
    }

    render() {
        return new Promise((resolve, reject) => {

            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            // Show modal popup window
            this.el = $(constants.SELECT_FIELD_ID).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 300,
                width: 500,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Commit',
                        'class': 'btn btn-default',
                        'disabled': false,
                        click: () => {
                            this.closeModal();
                            resolve('Ok');
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn btn-default',
                        click: () => {
                            this.closeModal();
                            resolve('Cancel');
                        }
                    }
                ],
                close: () => {
                    this.closeModal();
                },
                open: () => {
                    $(constants.SELECT_FIELD_ID).css('overflow', 'hidden')
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            $(".ui-dialog .ui-dialog-buttonpane").css( "text-align","center");
            $(".ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset").css("float", "none");
            this.delegateEvents();
            return this;
        });
    }

    clearEventBus() {
        eventBus.off(constants.FIELD_SELECTED);
        eventBus.off(constants.FIELD_SELECTED_CLEAR);
    }
}

export default SynchronizeCommitModalView;
